import { ItineraryV2UserRoles } from "@/types/itinerary/itineraryV2";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
// Define the structure of your decoded token
export interface DecodedToken {
  itineraryId: string;
  isRegistered: boolean;
  isLink: boolean;
  email: string;
  id: string;
  exp: number;
  iat: number;
  isInvited: boolean;
  city: string;
  country: string;
  senderEmail: string;
  role: "editor" | "commenter" | "viewer";
  days: number;
}

// Function to decode JWT
export const decodeToken = (token: string): DecodedToken | null => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
 
    return decoded;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return null;
  }
};
